import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@b4m/b4m-frontend-core';
import { DishSetComponent } from './dish-set.component';
import { DishSetAddEditComponent } from './dish-set-add-edit/dish-set-add-edit.component';
import { DishSetListComponent } from './dish-set-list/dish-set-list.component';
import { ClientResolve } from '../client-guard.service';

const dishSetRoutes: Routes = [
  {
    path: 'dish-sets',
    component: DishSetComponent,
    canActivate: [AuthGuard],
    resolve: [ClientResolve],
    data: { roles: ['ADMIN', 'USER'] },
    children: [
      {
        path: 'add',
        component: DishSetAddEditComponent,
        canActivate: [AuthGuard],
        canDeactivate: [AuthGuard],
        resolve: [ClientResolve],
        data: { roles: ['ADMIN', 'USER'] }
      },
      {
        path: 'edit/:id',
        component: DishSetAddEditComponent,
        canActivate: [AuthGuard],
        canDeactivate: [AuthGuard],
        resolve: [ClientResolve],
        data: { roles: ['ADMIN', 'USER'] }
      },
      {
        path: 'list',
        component: DishSetListComponent,
        canActivate: [AuthGuard],
        resolve: [ClientResolve],
        data: { roles: ['ADMIN', 'USER'] }
      }
    ]
  }
];

export const dishSetRouting = RouterModule.forChild(dishSetRoutes);
